import { deleteClass as deleteClassAPI } from "../api";

export const deleteClassAction = async (classID, setUser) => {
  const user = await deleteClassAPI(classID);
  setUser(user.data)
};
